import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "wrapper",
  class: "set-contacts"
}
const _hoisted_2 = { class: "set-contacts__form" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Magnify = _resolveComponent("Magnify")
  const _component_Close = _resolveComponent("Close")
  const _component_NcTextField = _resolveComponent("NcTextField")
  const _component_DialpadPanel = _resolveComponent("DialpadPanel")
  const _component_ContactSelectionBubble = _resolveComponent("ContactSelectionBubble")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")
  const _component_SelectPhoneNumber = _resolveComponent("SelectPhoneNumber")
  const _component_ParticipantsSearchResults = _resolveComponent("ParticipantsSearchResults")
  const _directive_intersection_observer = _resolveDirective("intersection-observer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_NcTextField, {
        ref: "setContacts",
        modelValue: $data.searchText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchText) = $event)),
        type: "text",
        class: "set-contacts__form-input",
        label: $options.textFieldLabel,
        "show-trailing-button": $options.isSearching,
        "trailing-button-label": $options.cancelSearchLabel,
        onTrailingButtonClick: $options.abortSearch,
        onInput: $options.handleInput
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_Magnify, { size: 20 })
        ]),
        "trailing-button-icon": _withCtx(() => [
          _createVNode(_component_Close, { size: 20 })
        ]),
        _: 1
      }, 8, ["modelValue", "label", "show-trailing-button", "trailing-button-label", "onTrailingButtonClick", "onInput"])), [
        [_directive_intersection_observer, $options.visibilityChanged]
      ]),
      ($props.canModerateSipDialOut)
        ? (_openBlock(), _createBlock(_component_DialpadPanel, {
            key: 0,
            value: $data.searchText,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => (($data.searchText) = $event)),
            container: ".set-contacts__form",
            onSubmit: $options.addParticipantPhone
          }, null, 8, ["value", "onSubmit"]))
        : _createCommentVNode("", true)
    ]),
    ($options.hasSelectedParticipants)
      ? (_openBlock(), _createBlock(_component_TransitionWrapper, {
          key: 0,
          class: "selected-participants",
          name: "zoom",
          tag: "div",
          group: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selectedParticipants, (participant) => {
              return (_openBlock(), _createBlock(_component_ContactSelectionBubble, {
                key: participant.source + participant.id,
                participant: participant,
                onUpdate: $options.updateSelectedParticipants
              }, null, 8, ["participant", "onUpdate"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($props.canModerateSipDialOut)
      ? (_openBlock(), _createBlock(_component_SelectPhoneNumber, {
          key: 1,
          "participant-phone-item": $data.participantPhoneItem,
          "onUpdate:participantPhoneItem": _cache[2] || (_cache[2] = $event => (($data.participantPhoneItem) = $event)),
          name: $options.t('spreed', 'Add a phone number'),
          value: $data.searchText,
          onSelect: $options.addParticipantPhone
        }, null, 8, ["participant-phone-item", "name", "value", "onSelect"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ParticipantsSearchResults, {
      "search-results": $data.searchResults,
      "contacts-loading": $data.contactsLoading,
      "no-results": $data.noResults,
      scrollable: "",
      "show-search-hints": !$props.onlyUsers,
      token: $props.token,
      "only-users": $props.onlyUsers,
      onClick: $options.updateSelectedParticipants,
      onClickSearchHint: $options.focusInput
    }, null, 8, ["search-results", "contacts-loading", "no-results", "show-search-hints", "token", "only-users", "onClick", "onClickSearchHint"])
  ], 512))
}